// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TableRowActions_wrapper_py8_9","button":"TableRowActions_button_1gJp4","isActive":"TableRowActions_isActive_3CgJb"};